import React, { useEffect, useRef, useState } from "react";
import { View, TouchableWithoutFeedback, AppState, LogBox } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { StatusBar } from "expo-status-bar";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { Provider as ReduxProvider } from "react-redux";
import { createStore } from "redux";
import { Provider as PaperProvider } from "react-native-paper";

import allReducers from "./components/redux/reducers";
import MainNavigation from "./navigation";
import useCachedResources from "./hooks/useCachedResources";
import useColorScheme from "./hooks/useColorScheme";
import { resetToLogin } from "./RootNavigation";

const mystore = createStore(allReducers);

export default function App() {
  const isLoadingComplete = useCachedResources();
  const colorScheme = useColorScheme();
  LogBox.ignoreLogs(["Require cycle: node_modules/victory"]);

  const timerRef = useRef(null);
  const appState = useRef(AppState.currentState);

  const handleLogout = async () => {

    await AsyncStorage.clear();

    if (typeof window !== "undefined") {
      localStorage.setItem("forceLogout", Date.now().toString());
    }

    resetToLogin();
  };

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(handleLogout, 1800000); // 30 minutes
  };

  useEffect(() => {
    resetTimer();

    const subscription = AppState.addEventListener("change", (nextAppState) => {
      if (
        appState.current.match(/inactive|background/) &&
        nextAppState === "active"
      ) {
        resetTimer();
      }
      appState.current = nextAppState;
    });

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      subscription.remove();
    };
  }, []);

  useEffect(() => {
    const handleStorageChange = async (event) => {
      if (event.key === "forceLogout") {
        await AsyncStorage.clear();
        resetToLogin();
      }
    };

    if (typeof window !== "undefined") {
      window.addEventListener("storage", handleStorageChange);
    }

    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("storage", handleStorageChange);
      }
    };
  }, []);

  if (!isLoadingComplete) {
    return null;
  }

  return (
    <PaperProvider>
      <SafeAreaProvider>
        <ReduxProvider store={mystore}>
          <TouchableWithoutFeedback onPress={resetTimer}>
            <View style={{ flex: 1 }}>
              <MainNavigation colorScheme={colorScheme} />
              <StatusBar />
            </View>
          </TouchableWithoutFeedback>
        </ReduxProvider>
      </SafeAreaProvider>
    </PaperProvider>
  );
}
